import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './authSlice';
// Configuración de redux-persist
const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['register'], // no persistir acciones de registro u otras
};

// Reducer persistido
const persistedReducer = persistReducer(persistConfig, authReducer);

// Creación del store
const store = configureStore({
  reducer: {
    auth: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Persistor para SSR o purgas manuales
const persistor = persistStore(store);

export { store, persistor };
